<template>
    <div class="modal is-active">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Confirmación de desconexión</p>
                <button class="delete" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <div v-if="closing">
                    <Loading />
                </div>
                <div class="field">
                    <label class="label">Tipo de desconexión</label>
                    <div class="control is-expanded">
                        <div class="select is-fullwidth">
                            <select v-model="disconnectionType" @change="changeDisconnectionType">
                                <option value="">Selecciona una razón</option>
                                <option v-for="(k, v) in options" :key="k" :value="k">
                                    {{ $t(`nomenclature.${v}`) }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="field">
                    <label class="label">Descripción</label>
                    <div class="control">
                        <textarea class="textarea" v-model="reason"></textarea>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" @click="disconect">
                    Enviar
                </button>
                <button class="button" @click="closeModal">
                    Cancelar
                </button>
                <div v-if="!closing">
                    <p v-if="haveError" class="has-text-danger">{{ error }}</p>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import Loading from "@/components/Loading";

export default {
    name: "disconnect-operator-modal",
    components: {
        Loading,
    },
    props: {
        userId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            closing: false,
            error: "",
            disconnectionType: "",
            reason: "",
            options: []
        };
    },
    computed: {
        haveError() {
            return this.error !== "";
        },
    },
    created() {
        this.getDisconnectionType();
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        changeDisconnectionType() {
            this.error = "";
        },
        async disconect() {
            if (this.disconnectionType === "") {
                this.error = "Debe ingresar el tipo de desconexión.";
                return;
            }
            
            this.$emit("closed", this.disconnectionType, this.reason);
        },
        async getDisconnectionType() {
            try {
                let response = await RepositoryFactory.nomenclature.getDisconnectionType();
                this.options = response.data;
            } catch (error) {
                window.console.log(error);
            }
        },
    },
};
</script>